const index = () => import(/* webpackChunkName: "herb" */ './Index');
const indusIndex = () => import(/* webpackChunkName: "herb" */ './indusIndex');
const innovationIndex = () => import(/* webpackChunkName: "herb" */ './innovationIndex');
const parkIndex = () => import(/* webpackChunkName: "herb" */ './parkIndex');

//2023年制造业重大项目方向补助资金
export default {
  routes: [
    {
      path: '/china/v2023/indusIndex',
      name: 'china_v2023_indus_index',
      component: indusIndex,
      meta:{public:true}
    },
    {
      path: '/china/v2023/innovationIndex',
      name: 'china_v2023_innovation_index',
      component: innovationIndex,
      meta:{public:true}
    },
    {
      path: '/china/v2023/parkIndex',
      name: 'china_v2023_park_index',
      component: parkIndex,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/china2025/V2023/router.js